// extracted by mini-css-extract-plugin
export default {"container":"PolicyInput_container__J2mdA","active":"PolicyInput_active__SlAQg"};